__turbopack_context__.v({
  "anchor": "Privacy-module__P5YMiW__anchor",
  "borders": "Privacy-module__P5YMiW__borders",
  "grayBackground": "Privacy-module__P5YMiW__grayBackground",
  "legalBasisModal": "Privacy-module__P5YMiW__legalBasisModal",
  "modalBody": "Privacy-module__P5YMiW__modalBody",
  "pageWrapper": "Privacy-module__P5YMiW__pageWrapper",
  "privacyCallout": "Privacy-module__P5YMiW__privacyCallout",
  "privacyInlineTable": "Privacy-module__P5YMiW__privacyInlineTable",
  "privacyTable": "Privacy-module__P5YMiW__privacyTable",
  "privacyTr": "Privacy-module__P5YMiW__privacyTr",
});
